import { RSCatalogScreen } from './components/RSCatalogScreen';

export const App = () => (
  <RSCatalogScreen
    catalog_url={process.env.PUBLIC_URL + '/rs_catalog.xlsx'}
    docs_url={process.env.PUBLIC_URL + '/rs_catalog_docs.zip'}
  />
);
